import { createContext } from 'react';

const MainSettingContext = createContext(null);

export default MainSettingContext;
